import { render } from "./add.vue?vue&type=template&id=8a7f84aa&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"

import "./add.vue?vue&type=style&index=0&id=8a7f84aa&lang=scss"
import "./add.vue?vue&type=style&index=1&id=8a7f84aa&lang=scss&scoped=true"

import exportComponent from "/Users/arvindersingh/Desktop/projects/parsoftwares/rt-backend/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a7f84aa"]])

export default __exports__